import { EmptyMessage } from '@/features/vfo/components';
import { BFC } from '@/shared/types';
import { useTranslation } from '@/shared/utils/i18n/useTranslation';

type EmptyWrapperProps = {
  isEmpty?: boolean;
};

export const EmptyWrapper: BFC<EmptyWrapperProps> = ({ isEmpty, children }) => {
  const { t } = useTranslation('pages/pageVfoAnalytics');

  if (isEmpty) {
    return <EmptyMessage iconName="chart-pie-slice" text={t('noAnalytics')} />;
  }
  return children;
};
